import { HighlightedDetailField } from "../../../components";
import { useMaterialListWithCache } from "../../../components/HubMaterialHookSelect/useMaterialListWithCache";

import { FieldGrid } from "../styles";
import { Section, SectionSubHeader } from "../components";

const PartAssembly = ({ section = {}, workOrder = {} }) => {
  const config = section?.config || {};

  const { materials: cached } = useMaterialListWithCache();
  const materials = Array.isArray(cached) ? cached : cached?.trees || [];

  const tree = workOrder?.treeId
    ? materials?.find((t) => t.id === workOrder.treeId)
    : null;

  return (
    <Section
      icon="GitBranch"
      label="Assembly Department"
      spanishLabel="Ensamblaje"
    >
      <SectionSubHeader label="Tree Setup" spanishLabel="Configuración del Árbol" />
      <FieldGrid columns={2}>
        <HighlightedDetailField
          label="Tree Type"
          spanishLabel="Tipo de Árbol"
          value={tree?.name ?? tree?.label}
        />
        <HighlightedDetailField
          label="Parts / Tree"
          spanishLabel="Piezas por Árbol"
          value={workOrder?.partsPerTree}
        />
      </FieldGrid>
      <FieldGrid columns={3}>
        <HighlightedDetailField
          label="Trees / Cluster"
          spanishLabel="Árboles por Grupo"
          value={config?.treesPerCluster}
        />
        <HighlightedDetailField
          label="Setup"
          spanishLabel="Configuración"
          value={config?.setup}
        />
        <HighlightedDetailField
          label="Tree Weight"
          spanishLabel="Peso del Árbol"
          value={config?.weight}
        />
      </FieldGrid>

      <SectionSubHeader label="Notes" spanishLabel="Notas" />
      <HighlightedDetailField
        label="Notes"
        spanishLabel="Notas"
        value={section?.notes}
      />
    </Section>
  );
};

export default PartAssembly;
